export const Z_INDEX = {
  LOGOUT_MODAL: 10000,
};
